import { loadingType } from '../../types/actions/app';
import { topicsListResponseType } from '../../types/topics';

const initialState = {
  topics: {
    items: [],
    total_entries: 0,
    skip: 0,
    limit: 12,
  },
  loading: {
    status: false,
    progress: 0,
  },
};

const topics = (
  state = initialState,
  action: {
    type: string;
    payload: {
      topics: topicsListResponseType;
      loading: loadingType;
    };
  },
): {
  topics: topicsListResponseType;
  loading: loadingType;
} => {
  switch (action.type) {
    case 'TOPICS_LIST':
      return Object.assign({}, state, {
        topics: action.payload.topics,
      });
    case 'TOPICS_LIST_LOADING':
      return Object.assign({}, state, {
        loading: action.payload.loading,
      });

    default:
      return state;
  }
};

export default topics;
